/** Collaborateur additionnel saisi dans un formulaire de création d'acteur. */
export interface CollaboratorDraft {
  firstName: string;
  lastName: string;
  email: string;
  /** Gérant du cabinet. */
  isOwner: boolean;
}

/** Résultat de la création d'un collaborateur (mot de passe temporaire ou erreur). */
export interface CollaboratorCreationResult {
  email: string;
  firstName: string;
  lastName: string;
  success: boolean;
  temporaryPassword?: string;
  error?: string;
}

export const emptyCollaboratorDraft = (): CollaboratorDraft => ({
  firstName: '',
  lastName: '',
  email: '',
  isOwner: false,
});
